export enum LifeTime {
    Short = 30,
    Long = 240
}